import { post } from "../helpers/request";
import { components } from "./api";

export const withdrawAsset = async (params: components["schemas"]["WithdrawOperationParams"]) => {
  return post(`/withdrawAsset`, params);
};
